import http from './httpClient';
import { setAccessToken, setUser, clearAccessToken, clearUser } from './tokenService';

export const isAuthenticated = (): boolean => !!localStorage.getItem('access_token');

export interface LoginResponse {
  access_token: string;
  user?: unknown;
}

export const login = async (ecode: string, password: string): Promise<unknown> => {
  const data = await http.post('/api/v1/auth/login', { ecode, password }, { retry: false }) as LoginResponse;
  if (!data?.access_token) throw new Error('No access token');
  setAccessToken(data.access_token);
  if (data.user) setUser(data.user);
  return data.user ?? null;
};


export interface UserWithRolesAndPermissions {
  ecode: string;
  full_name: string;
  roles: string[];
  perms: string[];
}

export const fetchMePermissions = async (): Promise<UserWithRolesAndPermissions> => {
  const me = await http.get<UserWithRolesAndPermissions | null>('/api/v1/auth/me/permissions');
  // Do not cache permissions
  return me || { ecode: '', full_name: '', roles: [], perms: [] };
};

export const logout = async (): Promise<void> => {
  try { await http.post('/api/v1/auth/logout', null, { retry: false }); }
  catch(error) {
    console.error('Error during logout:', error);
   }
  finally {
    clearAccessToken();
    clearUser();
  }
};



export interface MenuPermission {
  menu_id: number
  menu_desc: string
  route_path: string
  icon_name: string
  display_order: number
  submenu?: MenuPermission[]
}

export interface PermissionsResponse {
  permissions: MenuPermission[]
}

export const fetchPermissions = async (): Promise<MenuPermission[]> => {
  const data = await http.get<PermissionsResponse>("/api/v1/auth/menu-permissions")
  return data.permissions || []
}